

















































































import { TbMember, TbReturnOrder } from '@/http';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
@Component({
    components: {
    },
})
export default class changePricePanel extends Vue {
    public $refs: {
    };
    @Prop({
        default:""
    })
    originForm:string;

    @Prop({
        type:Object,
        default:()=>{
            return{
                id:"",
                name:"",
                gradeDiscount:null,
            }
        }
    })
    memberInfo;

    show=false;
   
    fmoney = fmoney;

    isGoodDiscount=true;
  
    /**1:打折；2：一口价 */
    editNumType = 1;
    form:any={};
    /**键盘 */
    value=null;
    maxLength=10;

    discountPriceNew=0;

    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }

    /**折后价:售价 * 商品折扣 * 会员折扣 */
    get discountPrice(){
        let val = 0;
        let sellingPrice = this.form.sellingPrice?this.form.sellingPrice:0;
        let discountPrice =  0;
        if(this.isGoodDiscount){
            if(this.editNumType==1&&this.form.goodDiscount){
                discountPrice = calculate.multiplication(sellingPrice,(calculate.multiplication(this.form.goodDiscount,0.1)));
            }else{
                discountPrice = this.discountPriceNew;
            }
        }else{
            discountPrice=sellingPrice;
        }
        let gradeDiscount = this.form.isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;
        if(discountPrice){
            val = calculate.multiplication(discountPrice,gradeDiscount);
        }else{
            val = calculate.multiplication(sellingPrice,gradeDiscount);
        }
        return val;
    }
    /**单品优惠 */
    get getYh(){
        let val = '';
        val = '-'+fmoney(Math.abs(calculate.subtraction(this.discountPrice,this.form.sellingPrice)),2,true);
        return val;
    }

    created() {
    }   
    
    mounted() {
       
    }
    showFun(){
        this.show = true;
        this.$nextTick(()=>{
            this.form = JSON.parse(this.originForm);
            if(this.form.goodDiscount==0&&this.form.sellingPrice==this.form.discountPrice){
                this.editNumType =null;
                this.discountPriceNew= null;
                this.isGoodDiscount = false;
            }else{
                this.editNumType = Number(this.form.goodDiscount==10)?null:this.form.goodDiscount?1:2;
                this.maxLength = this.editNumType==1?3:10;
                this.discountPriceNew= this.form.discountPrice;
                this.isGoodDiscount = Number(this.form.goodDiscount==10)?false:true;
            }
        })
    }
    closeFun(){
        this.show = false;
    }
    saveFun(){

    }
    onChange(event,type){
        const detail = event;
        switch (type) {
            case 1:
                this.isGoodDiscount = detail;
                if(!detail){
                    this.form.goodDiscount = null;
                    this.discountPriceNew = null;
                    this.editNumType=null;
                }
                break;
            case 2:
                this.form.isMemberDiscount = detail;
                break;
            case 3:
                this.form.isDiscount = detail;
                break;
            case 4:
                this.form.isIntegral = detail;
                break;
        
            default:
                break;
        }
    }
    setNumVal(val){
        this.value = val;
    }

    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun();
        }
	number(number) {
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}


	clearFun(){
            this.value = null;
            this.finishFun();
    }
    finishFun(){
        if(this.editNumType==1){
            if(this.value&&(Number(this.value)>9.9)){
                Toast("折扣请输入0.1-9.9");
                this.value=null;
            }
            this.form.goodDiscount = this.value;
        }else{
            if(this.value&&Number(this.value)==Number(this.form.sellingPrice)){
                Toast("一口价不可等于单价");
                this.value=null;
            }
            if(this.value&&Number(this.value)>Number(this.form.sellingPrice)){
                Toast("一口价不可大于单价");
                this.value=null;
            }
            this.discountPriceNew = this.value;
        }
        this.$forceUpdate();
    }
    onDiscountChange(val){
        this.editNumType = val;
        if(val==1){
            this.maxLength=3;
        }else{
            this.maxLength=10;
            this.form.goodDiscount = 0;
        }
        this.clearFun();
    }
    /**判断权限 */
    hasAuth(auth) {
        let userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        let val = false;
        let btnPermissionsStr = userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    confirmFun(){    
        if(this.isGoodDiscount&&!this.editNumType){
            Toast('请填写相应折扣');
            return;
        }
        if(this.isGoodDiscount&&this.editNumType==1&&(!this.form.goodDiscount||Number(this.form.goodDiscount)==0)){
            Toast('请输入折扣');
            return;
        }
        if(this.isGoodDiscount&&this.editNumType==2&&(!this.discountPriceNew||Number(this.discountPriceNew)===0)){
            Toast('请输入一口价');
            return;
        }
        let oldForm = JSON.parse(this.originForm);
        console.log('oldForm',oldForm);
        
        let obj = Object.assign({},this.form,{isChangePrice:true,discountPrice:this.isGoodDiscount?this.editNumType==1 ?calculate.multiplication(calculate.multiplication(this.form.goodDiscount,0.1),this.form.sellingPrice):this.discountPriceNew:this.form.sellingPrice,goodDiscount:this.form.goodDiscount?this.form.goodDiscount:0,
            showPrice_DiscountPrice:this.discountPrice,discountPriceOld:this.form.isChangePrice?oldForm.discountPriceOld:oldForm.discountPrice,goodDiscountOld:this.form.isChangePrice?oldForm.goodDiscountOld:oldForm.goodDiscount,isDiscountOld:this.form.isChangePrice?oldForm.isDiscountOld:oldForm.isDiscount,
            isMemberDiscountOld:this.form.isChangePrice?oldForm.isMemberDiscountOld:oldForm.isMemberDiscount,isIntegralOld:this.form.isChangePrice?oldForm.isIntegralOld:oldForm.isIntegral,showPrice_DiscountPriceOld:this.form.isChangePrice?oldForm.showPrice_DiscountPriceOld:oldForm.discountPrice
        });
        this.$emit("editProduct",obj);
        this.closeFun();
        
    }
    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/changePricePanel.vue